// @flow

export const LOAD: 'VEHICLE.LOAD' = 'VEHICLE.LOAD';
export const SET: 'VEHICLE.SET' = 'VEHICLE.SET';
export const UNSET: 'VEHICLE.UNSET' = 'VEHICLE.UNSET';
export const CREATE: 'VEHICLE.CREATE' = 'VEHICLE.CREATE';